var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80.9 104.6",
    style: {
      enableBackground: "new 0 0 80.9 104.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -13.2109,
    y1: -21.8392,
    x2: 49.6164,
    y2: 86.9809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,65.5c0.7,1.3,2.2,1.6,3.3,0.7l20.8-15.4c1.2-0.9,1.3-2.4,0.2-3.4L29.5,32.9c-1-1-3-2.1-4.4-2.4L3.5,25.8 c1.1,4.5,1.9,9.1,2.5,13.8L19.8,65.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.7488,
    y1: -5.3628,
    x2: 21.0785,
    y2: 103.4573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,74.4l-4.4-0.8c-0.5,2.7-1.1,5.3-1.9,7.8l6.7-5C10.7,75.6,10.5,74.6,9.1,74.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.2383,
    y1: -9.699,
    x2: 28.589,
    y2: 99.1211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.3,68.1L6.7,52c0,5.5-0.4,11-1.2,16.4l8.4,1.5C15.3,70.2,16,69.4,15.3,68.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -13.8733,
    y1: -21.4567,
    x2: 48.954,
    y2: 87.3634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.6,24.9L1.9,5.2c-2.4,4-2.6,10.1,0.6,17l18.3,4C22.3,26.5,22.6,25.9,21.6,24.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.0488,
    y1: -33.5361,
    x2: 69.8761,
    y2: 75.284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.4,29.3l26.4,5.7c1.4,0.3,3.5-0.1,4.6-1l0.9-0.7c-14.4-11-28.8-21-44.8-29.8c-6.9-4-12.9-4.3-17-2L31,26.9 C32,28,34,29,35.4,29.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.2494,
    y1: -34.2293,
    x2: 71.0767,
    y2: 74.5908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.4,37.7l-18.7-4.1c-1.4-0.3-1.7,0.3-0.7,1.3l9.4,9.4c1,1,2.8,1.1,3.9,0.3l6.5-4.8 C60,38.9,59.8,38,58.4,37.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -18.2505,
    y1: -18.9296,
    x2: 44.5769,
    y2: 89.8905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.4,79.8l7.4,14c5.9-3.7,11.7-7.5,17.4-11.5L28.8,78C27.3,77.8,26.7,78.6,27.4,79.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.6227,
    y1: -24.4882,
    x2: 54.2046,
    y2: 84.3319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51.6,54.9c-1-1-2.8-1.1-3.9-0.3L26.4,70.3c-1.2,0.9-0.9,1.8,0.5,2l31.2,5.8c3.2-2.3,6.4-4.7,9.5-7.1 L51.6,54.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7775,
    y1: -39.153,
    x2: 79.6048,
    y2: 69.6671
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.6,41.2L56,48.3c-1.2,0.9-1.3,2.4-0.2,3.4l16.1,16.1c10.1-7.4,11.5-17.7,4.9-26.2l-6.5-1.4 C68.8,39.9,66.7,40.4,65.6,41.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.7589,
    y1: -4.7796,
    x2: 20.0684,
    y2: 104.0405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.1,76.2c-0.3-0.1-1.4,0.6-2.6,1.5L0.3,89.8c-1.7,12.3,8.6,19.3,22.3,11.2c2.6-1.5,5.2-2.9,7.8-4.5 l-9.5-17.9C20.2,77.4,19.4,76.3,19.1,76.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.620abd8c69883f0881885af5d28a7aef.svg";
export { ForwardRef as ReactComponent };